// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__37TNc","title":"Title_title__xLFBB"};